/**
 * Create Test Mention Script
 * Creates a test mention to trigger the messaging system
 *
 * USAGE: await window.createTestMention()
 */

import { collection, doc, setDoc, serverTimestamp, query, where, getDocs } from 'firebase/firestore';
import { db } from '../firebase.js';

async function createTestMention() {
  console.log('🔄 Creating test mention for messaging system...\n');

  try {
    const schoolId = 'hktnikYSv6l6vGPbjMmG';
    const studentId = 'nZiruuT9AOvljI99pYHJ';
    
    // First verify the student exists
    const studentsRef = collection(db, 'schools', schoolId, 'students');
    const studentQuery = query(studentsRef, where('id', '==', studentId));
    const studentSnapshot = await getDocs(studentQuery);
    
    if (studentSnapshot.empty) {
      console.log('❌ Student not found:', studentId);
      return { success: false, error: 'Student not found' };
    }
    
    const studentData = studentSnapshot.docs[0].data();
    console.log('✅ Found student:', studentData.firstName, studentData.lastName);
    
    // Create the test mention
    const mentionData = {
      schoolId: schoolId,
      studentId: studentId,
      studentName: `${studentData.firstName} ${studentData.lastName}`,
      classId: studentData.classId || 'test-class',
      className: studentData.className || 'Test Class',
      teacherId: 'test-teacher-1',
      teacherName: 'Test Teacher',
      offense: 'Test offense for messaging verification',
      offenseCategory: 'Test Category',
      offenseCategoryId: 'test-category-1',
      severity: 'low',
      description: 'This is a test mention to verify the messaging system is working. It should trigger message creation and queue processing.',
      timestamp: new Date().toISOString(),
      status: 'active',
      type: 'behavior',
      points: 1,
      // Add message trigger flag if needed
      triggerMessage: true
    };
    
    // Create the mention document
    const mentionRef = doc(collection(db, 'schools', schoolId, 'mentions'));
    await setDoc(mentionRef, {
      ...mentionData,
      createdAt: serverTimestamp(),
      id: mentionRef.id
    });
    
    console.log('✅ Test mention created successfully!');
    console.log('📋 Details:');
    console.log('   Mention ID:', mentionRef.id);
    console.log('   School ID:', schoolId);
    console.log('   Student ID:', studentId);
    console.log('   Student Name:', mentionData.studentName);
    console.log('   Offense:', mentionData.offense);
    console.log('   Message Trigger:', mentionData.triggerMessage);
    console.log('');
    console.log('🔥 This should now trigger:');
    console.log('   1. Mention trigger to create message');
    console.log('   2. Queue processor to find message in next cycle');
    console.log('   3. Telegram notification to verified parent');
    
    return { 
      success: true, 
      mentionId: mentionRef.id,
      schoolId: schoolId,
      studentId: studentId,
      studentName: mentionData.studentName
    };
    
  } catch (error) {
    console.error('❌ Error creating test mention:', error);
    throw error;
  }
}

export { createTestMention };